import { combineReducers } from '@reduxjs/toolkit';
import appReducer, { ReduxAppsState } from '../applications/reducers/appReducer';
import userReducer, { ReduxUserState } from '../user/reducers/userReducer';
import orgReducer, { ReduxOrgState } from '../organisation/reducer/orgReducer';
import adminAppReducer, { ReduxAdminAppsState } from '../admin/reducers/adminAppReducer';
import adminUserReducer, { ReduxAdminUsersState } from '../admin/reducers/adminUserReducer';

interface RootReducerInterface {
  appReducer: ReduxAppsState;
  userReducer: ReduxUserState;
  orgReducer: ReduxOrgState;
  adminAppReducer: ReduxAdminAppsState;
  adminUserReducer: ReduxAdminUsersState;
}

const rootReducer = combineReducers<RootReducerInterface>({
  appReducer,
  userReducer,
  orgReducer,
  adminAppReducer,
  adminUserReducer,
});

export type AppState = ReturnType<typeof rootReducer>;

export default rootReducer;
